export interface JwtPayload {
  sub: string; // subject (user ID)
  jti?: string; // JWT ID
  roles: string[]; // user roles (e.g., ["ADMIN"])
  tokenVersion?: number; // token version for revocation
  iat: number; // issued at
  exp: number; // expiration
}

/**
 * Decode JWT token payload (client-side only for getting user info)
 * Note: This is NOT for security validation, only for extracting user data
 */
export const decodeJwtPayload = (token: string): JwtPayload | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded) as JwtPayload;
  } catch (error) {
    console.error('Failed to decode JWT payload:', error);
    return null;
  }
};

/**
 * Check if JWT token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  const payload = decodeJwtPayload(token);
  if (!payload) {
    return true;
  }

  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now;
};

/**
 * Get user ID from JWT token
 */
export const getUserIdFromToken = (token: string): string | null => {
  const payload = decodeJwtPayload(token);
  return payload?.sub || null;
};